import { useCallback, useMemo, useEffect } from 'react';

export const useTelegramHaptic = () => {
  const webApp = window.Telegram?.WebApp;
  const hapticFeedback = webApp?.HapticFeedback;
  
  // Ensure WebApp is ready
  useEffect(() => {
    if (webApp && webApp.ready) {
      webApp.ready();
    }
  }, [webApp]);
  
  // Check if haptic feedback is supported
  const isSupported = useMemo(() => {
    if (!webApp || !hapticFeedback) return false;
    
    // Parse version to check if >= 6.1
    const version = webApp.version || '6.0';
    const [major, minor] = version.split('.').map(v => parseInt(v) || 0);
    
    
    // For iOS, try to use haptic feedback even if version reports as 6.0
    // as the version might be incorrectly reported
    const isIOS = webApp.platform === 'ios';
    if (isIOS && hapticFeedback) {
      return true;
    }
    
    // HapticFeedback requires version 6.1 or higher
    const supported = major > 6 || (major === 6 && minor >= 1);
    
    return supported;
  }, [webApp, hapticFeedback]);
  

  const selectionChanged = useCallback(() => {
    if (isSupported && hapticFeedback?.selectionChanged) {
      try {
        hapticFeedback.selectionChanged();
      } catch (e) {
        console.warn('[TelegramHaptic] Failed to trigger selection haptic:', e);
      }
    }
  }, [hapticFeedback, isSupported]);

  const notificationOccurred = useCallback((type) => {
    if (isSupported && hapticFeedback?.notificationOccurred) {
      try {
        hapticFeedback.notificationOccurred(type);
      } catch (e) {
        console.warn('[TelegramHaptic] Failed to trigger notification haptic:', e);
      }
    }
  }, [hapticFeedback, isSupported]);
  
  // Add impactOccurred as an alternative method
  const impactOccurred = useCallback((style = 'light') => {
    if (isSupported && hapticFeedback?.impactOccurred) {
      try {
        hapticFeedback.impactOccurred(style);
      } catch (e) {
        console.warn('[TelegramHaptic] Failed to trigger impact haptic:', e);
      }
    }
  }, [hapticFeedback, isSupported]);

  return {
    selectionChanged,
    notificationOccurred,
    impactOccurred,
    isAvailable: isSupported,
    version: webApp?.version || 'unknown',
    platform: webApp?.platform || 'unknown'
  };
};